import askGithub from './../lib/askGithub'
//import ERROR_CODES from './../lib/errorCodes'

/**
 * Gets all the users branches for a particular repository. Assumes if the
 * user made a commit to a branch then it counts it as a users branch
 * @param {string} token
 * @param {string} repoId
 */
async function getUsersBranches(token, repoId){

  var result = await askGithub(token, `query {
    viewer {
      id
      login
    }
  }`)
  var { id: authorId } = result['data']['viewer']

  // Get the repo name
  var result = await askGithub(token, `query {
    node(id:"${repoId}") {
      ... on Repository {
        name
        owner {
          id
          login
        }
      }
    }
  }`)
  var name = result['data']['node']['name']
  var owner = result['data']['node']['owner']['login']

  var result = await askGithub(token, `query($owner:String!, $name:String!, $branchCursor: String!) {
    repository(owner: $owner, name: $name) {
      refs(first: 100, refPrefix: "refs/heads/",after: $branchCursor) {
        totalCount
        edges {
          node {
            id
            name
            target {
              ...on Commit {
                history(author: { id: "${authorId}"}, first: 1){
                  totalCount,
                  edges {
                    node {
                      committer {
                        date
                        email
                        name
                      },
                      pushedDate,
                      message,
                      id
                    }
                  }
                }
              }
            }
          }
        }
        pageInfo {
          endCursor
          hasNextPage
        }
      }
    }
  }`, `{
    "owner": "${owner}",
    "name": "${name}",
    "branchCursor": ""
  }`)

  var branches = result['data']['repository']['refs']['edges'].map(edge => {
    var branch = edge['node']
    return {
      id: branch['id'],
      name: branch['name'],
      repositoryId: repoId,
    }
  })

  return branches
}

export default getUsersBranches


// WEBPACK FOOTER //
// ./src/data/getUsersBranches.js